import type { Matter } from "@/shared/cache";
import { matterLookupText } from "@/shared/utils/matterLabels";
import type {
  Activity as ActivityOption,
  Task as TaskOption,
} from "@/v2/components/entry-form/useCodeOptions";

export function renderTaskItem(item: TaskOption) {
  return (
    <div className="flex flex-col py-0.5 min-w-0">
      <span className="text-sm font-semibold leading-tight truncate">{item.task}</span>
      <span className="text-sm text-muted-foreground leading-tight truncate">
        {item.taskDescription}
      </span>
    </div>
  );
}

export function renderActivityItem(item: ActivityOption) {
  return (
    <div className="flex flex-col py-0.5 min-w-0">
      <span className="text-sm font-semibold leading-tight truncate">
        {item.activity}
      </span>
      <span className="text-sm text-muted-foreground leading-tight truncate">
        {item.activityDescription}
      </span>
    </div>
  );
}

export function renderMatterItem(item: Matter) {
  return (
    <div className="flex flex-col py-0.5 min-w-0">
      <span className="text-sm font-semibold leading-tight truncate">
        {matterLookupText(item)}
      </span>
      <span className="text-sm text-muted-foreground leading-snug whitespace-normal break-words">
        {item.description.trim()}
      </span>
      <span className="text-xs text-muted-foreground/70 leading-tight truncate">
        {item.client.trim()}
      </span>
    </div>
  );
}

export function renderSelectedMatter(item: Matter) {
  return (
    <div className="flex flex-col py-0.5 min-w-0">
      <span className="text-sm font-semibold leading-tight truncate">
        {matterLookupText(item)}
      </span>
      <span className="text-sm text-muted-foreground leading-snug truncate">
        {item.description.trim()}
      </span>
      <span className="text-xs text-muted-foreground/70 leading-tight truncate">
        {item.client.trim()}
      </span>
    </div>
  );
}
